module.exports = __webpack_public_path__ + "img/product-plsc-three.b73556c.png";